import { render, staticRenderFns } from "./DraftAIGC.vue?vue&type=template&id=a08152c2&scoped=true&"
import script from "./DraftAIGC.vue?vue&type=script&lang=js&"
export * from "./DraftAIGC.vue?vue&type=script&lang=js&"
import style0 from "./DraftAIGC.vue?vue&type=style&index=0&id=a08152c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08152c2",
  null
  
)

export default component.exports